// Desktop builds authenticate with a bearer token instead of cookies.
//
// The desktop app is served from http://localhost:<port> while the API lives on
// another origin (https://api.austinwilcox.dev). The session cookie is therefore
// a third-party cookie, which the desktop webview (WKWebView on macOS) blocks —
// so after login the session couldn't be read and the app bounced back to /login.
// The bearer token (stored from the `set-auth-token` response header and sent as
// `Authorization: Bearer`) sidesteps cookies entirely.
//
// Enabled only when VITE_DESKTOP=true (set by scripts/build-desktop.sh); the web
// build keeps using cookies unchanged.
export const IS_DESKTOP = import.meta.env.VITE_DESKTOP === "true"

const BEARER_TOKEN_KEY = "openiron_bearer_token"

export function getBearerToken(): string | null {
  if (!IS_DESKTOP) {
    return null
  }
  try {
    return localStorage.getItem(BEARER_TOKEN_KEY)
  } catch {
    return null
  }
}

export function setBearerToken(token: string): void {
  try {
    localStorage.setItem(BEARER_TOKEN_KEY, token)
  } catch {
    // ignore storage failures (private mode, etc.)
  }
}

export function clearBearerToken(): void {
  try {
    localStorage.removeItem(BEARER_TOKEN_KEY)
  } catch {
    // ignore
  }
}
